module.exports = __webpack_public_path__ + "static/media/plus.73e14575.svg";